import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import api from "../services/api";

const loggedIn = () =>
  localStorage.getItem("authToken") && localStorage.getItem("isGuest") !== "true";

export default function ReferFriend() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/referrals/me")
      .then((r) => setData(r.data))
      .catch(() => setData({ enabled: false }))
      .finally(() => setLoading(false));
  }, []);

  const copy = (text) => {
    navigator.clipboard?.writeText(text).then(
      () => toast.success(t("refer.copied")),
      () => toast.info(text)
    );
  };

  const wrap = (inner) => (
    <Container className="my-5" style={{ minHeight: "50vh", maxWidth: 720 }}>
      <ToastContainer position="bottom-right" autoClose={3000} />
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, marginBottom: 24 }}>{t("refer.title")}</h2>
      {inner}
    </Container>
  );

  if (loading) return wrap(<p className="text-muted">{t("wishlist.loading")}</p>);
  if (!loggedIn()) {
    return wrap(
      <div className="text-center py-5">
        <p className="text-muted mb-3">{t("refer.loginPrompt")}</p>
        <Link to="/login" className="btn btn-warning">{t("nav.login")}</Link>
      </div>
    );
  }
  if (!data || data.enabled === false) {
    return wrap(<p className="text-muted">{t("refer.unavailable")}</p>);
  }

  return wrap(
    <>
      <div style={{ background: "#221f1a", borderRadius: 16, padding: "28px 24px", color: "#fff", textAlign: "center", marginBottom: 24 }}>
        <div style={{ fontSize: 40 }}>🎁</div>
        <div style={{ fontSize: "1.4rem", fontWeight: 800, marginTop: 8 }}>
          {t("refer.giveGet", { give: data.referee_points, get: data.referrer_points })}
        </div>
        <div style={{ color: "#c9c2b6", marginTop: 8, fontSize: "0.95rem" }}>
          {t("refer.how")}
        </div>
      </div>

      <label className="fw-semibold mb-1 d-block">{t("refer.yourLink")}</label>
      <div className="d-flex gap-2 mb-3">
        <input className="form-control" readOnly value={data.link} onFocus={(e) => e.target.select()} />
        <button className="btn btn-dark" onClick={() => copy(data.link)}>{t("refer.copy")}</button>
      </div>

      <label className="fw-semibold mb-1 d-block">{t("refer.orCode")}</label>
      <div className="d-flex gap-2 mb-4">
        <input className="form-control text-uppercase fw-bold" readOnly value={data.code} style={{ letterSpacing: 2, maxWidth: 220 }} />
        <button className="btn btn-outline-dark" onClick={() => copy(data.code)}>{t("refer.copyCode")}</button>
      </div>

      <div className="d-flex gap-4">
        <div>
          <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#1a5c38" }}>{data.referred_count}</div>
          <div className="text-muted small">{t("refer.friendsReferred")}</div>
        </div>
        <div>
          <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#1a5c38" }}>{data.points_earned}</div>
          <div className="text-muted small">{t("refer.pointsEarned")}</div>
        </div>
        <div>
          <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#111" }}>{data.rewarded_count}</div>
          <div className="text-muted small">{t("refer.completedOrders")}</div>
        </div>
      </div>
    </>
  );
}
